define.alias("shared/components/shared/credentials/instagram-auth-status", "settings/components/shared/credentials/instagram-auth-status");